import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "selection-products" }
const _hoisted_2 = { class: "selection-products__selected-items" }
const _hoisted_3 = {
  key: 0,
  class: "selection-products__selected-text"
}
const _hoisted_4 = { class: "selection-products__selected-count" }
const _hoisted_5 = {
  key: 1,
  class: "selection-products__placeholder"
}
const _hoisted_6 = {
  key: 0,
  class: "invalid-msg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TreeSelectionProductsModal = _resolveComponent("TreeSelectionProductsModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["selection-products__content", {
        'selection-products__content_error': _ctx.v$.selectedIdsProps.$error && _ctx.v$.selectedIdsProps.required.$invalid,
        'selection-products__content_disabled': _ctx.disabled,
      }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.selectedIDs.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[2] || (_cache[2] = _createElementVNode("span", null, "Выбрано", -1)),
              _createElementVNode("span", _hoisted_4, [
                _createElementVNode("span", null, _toDisplayString(_ctx.selectedIDs.length), 1)
              ]),
              _createElementVNode("div", {
                class: "selection-products__clear",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteAll && _ctx.deleteAll(...args)), ["stop"]))
              })
            ]))
          : _createCommentVNode("", true),
        (!_ctx.selectedIDs.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Выберите"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: "selection-products__custom-button add",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.catalogModal = true), ["prevent","stop"]))
      }, "Список"),
      _createVNode(_component_TreeSelectionProductsModal, {
        isShow: _ctx.catalogModal,
        selectedIds: _ctx.selectedIDs,
        multiple: _ctx.multiple,
        selectGroupsOnly: _ctx.selectGroupsOnly,
        selectLeafsOnly: _ctx.selectLeafsOnly,
        codes: _ctx.codes,
        fetcher: _ctx.fetcher,
        onClose: _ctx.closeCatalog,
        onSelect: _ctx.updateProducts,
        onUpdateSelectedItems: _ctx.updateSelectedItems
      }, null, 8, ["isShow", "selectedIds", "multiple", "selectGroupsOnly", "selectLeafsOnly", "codes", "fetcher", "onClose", "onSelect", "onUpdateSelectedItems"])
    ], 2),
    (_ctx.v$.selectedIdsProps.$error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.v$.selectedIdsProps.required.$invalid)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("Поле обязательно для заполнения")
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}